import { buildCalendarMonthRange, buildCalendarQuarterRange } from '../../../filters/lib/statisticsPeriodQuickPickUtils';
import { PERIOD_YOY_GRANULARITY } from '../../../filters/lib/statisticsPeriodYoyHelpers';

const parseSeriesYear = (seriesName = '') => {
	const match = String(seriesName).match(/^(\d{4})年/);
	if (!match) return null;
	const year = Number(match[1]);
	return Number.isFinite(year) ? year : null;
};

export const parseCompareSeriesMetricLabel = (seriesName = '') => {
	const parts = String(seriesName)
		.split('·')
		.map((part) => part.trim())
		.filter(Boolean);
	if (parts.length < 2) return null;
	return parts.slice(1).join(' · ').replace(/（基准）$/, '').trim() || null;
};

const resolveChartClickValue = (params) => {
	const data = params?.data;
	if (data && typeof data === 'object' && 'value' in data) {
		const value = Number(data.value);
		return Number.isFinite(value) ? value : null;
	}
	const raw = params?.value;
	if (Array.isArray(raw)) {
		const value = Number(raw[raw.length - 1]);
		return Number.isFinite(value) ? value : null;
	}
	const value = Number(raw);
	return Number.isFinite(value) ? value : null;
};

export const resolveLineCompareYearMonthsDrill = ({
	seriesName,
	dataIndex,
	periodIndices = null,
	granularity = PERIOD_YOY_GRANULARITY.MONTH,
	seriesType = null,
	chartValue = null,
}) => {
	if (dataIndex == null || dataIndex < 0) return null;

	const year = parseSeriesYear(seriesName);
	if (year == null) return null;

	const periodIndex = Array.isArray(periodIndices) && periodIndices.length ? periodIndices[dataIndex] : dataIndex;
	if (periodIndex == null || periodIndex < 0) return null;

	const range =
		granularity === PERIOD_YOY_GRANULARITY.QUARTER
			? buildCalendarQuarterRange(year, periodIndex)
			: buildCalendarMonthRange(year, periodIndex);
	if (!range?.startDate || !range?.endDate) return null;

	const periodLabel =
		granularity === PERIOD_YOY_GRANULARITY.QUARTER ? `Q${periodIndex + 1}` : `${periodIndex + 1}月`;

	return {
		kind: 'trendTime',
		startDate: range.startDate,
		endDate: range.endDate,
		label: `${year}年${periodLabel}`,
		metricLabel: parseCompareSeriesMetricLabel(seriesName),
		seriesType: seriesType || null,
		chartValue: chartValue != null && Number.isFinite(Number(chartValue)) ? Number(chartValue) : null,
	};
};

export const resolveLineCompareYearMonthsDrillFromChartClick = (params, { periodIndices, granularity } = {}) =>
	resolveLineCompareYearMonthsDrill({
		seriesName: params?.seriesName,
		dataIndex: params?.dataIndex,
		periodIndices,
		granularity,
		seriesType: params?.seriesType ?? null,
		chartValue: resolveChartClickValue(params),
	});

export const resolveLineComparePeriodTimelineDrill = ({ points = [], dataIndex, seriesName = null }) => {
	if (dataIndex == null || dataIndex < 0) return null;
	const point = points[dataIndex];
	if (!point?.startDate || !point?.endDate) return null;

	return {
		kind: 'trendTime',
		startDate: point.startDate,
		endDate: point.endDate,
		label: point.label ?? point.axisLabel ?? point.title ?? '对比区间',
		metricLabel: parseCompareSeriesMetricLabel(seriesName),
	};
};

export default resolveLineCompareYearMonthsDrill;
